export default {
  'package.field.code': 'Code',
  'package.field.name': 'Name',
  'package.field.description': 'Description',
  'package.field.ams_code': 'AMS Code',
  'package.field.emanifest_code': 'eManifest Code',
  'package.unit.empty': 'No Package Units',
};
